import { render, staticRenderFns } from "./exchangeRecords.vue?vue&type=template&id=6eb503cc&scoped=true"
import script from "./exchangeRecords.vue?vue&type=script&lang=js"
export * from "./exchangeRecords.vue?vue&type=script&lang=js"
import style0 from "./exchangeRecords.vue?vue&type=style&index=0&id=6eb503cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb503cc",
  null
  
)

export default component.exports